(() => {
  if (customElements.get('oumo-set-sale')) return;
  const duration = 5 * 60 * 60 * 1000;
  const key = 'oumo-set-sale-visitor-start-v1';
  let memoryStart;
  function getStart(now) {
    let stored;
    try { stored = localStorage.getItem(key); } catch (_) {}
    const parsed = stored === null || stored === undefined ? NaN : Number(stored);
    if (Number.isFinite(parsed) && parsed > 0 && parsed <= now) {
      memoryStart = parsed;
    } else if (!Number.isFinite(memoryStart) || memoryStart > now) {
      memoryStart = now;
      try { localStorage.setItem(key, String(memoryStart)); } catch (_) {}
    }
    return memoryStart;
  }
  customElements.define('oumo-set-sale', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      const update = () => {
        const now = Date.now();
        const elapsed = Math.max(0, now - getStart(now));
        const left = Math.ceil((duration - elapsed % duration) / 1000);
        const parts = [Math.floor(left / 3600), Math.floor(left % 3600 / 60), left % 60];
        const clock = this.querySelector('[data-countdown]');
        if (clock) clock.textContent = parts.map(n => String(n).padStart(2, '0')).join(':');
      };
      update();
      this.timer = setInterval(update, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
})();
